
// 格式化时间
export default {
  parseTime: function (time, tips) {
    if (tips) {
      return tips
    }
    if (arguments.length === 0 || !time) {
      return null
    }
    const format = '{y}-{m}-{d}'
    let date
    if (typeof time === 'object') {
      date = time
    } else {
      if (('' + time).length === 10) time = parseInt(time) * 1000
      date = new Date(time)
    }
    const formatObj = {
      y: date.getFullYear(),
      m: date.getMonth() + 1,
      d: date.getDate()
    }
    const timeStr = format.replace(/{(y|m|d)+}/g, (result, key) => {
      let value = formatObj[key]
      if (key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1]
      if (result.length > 0 && value < 10) {
        value = '0' + value
      }
      return value || 0
    })
    return timeStr
  }
}
// if (!TextUtils.isEmpty(order.getTips())) {
//   viewHolder.tv_voucherDate.setTextColor(mContext.getResources().getColor(R.color.color_F77A42));
//   viewHolder.tv_voucherDate.setText(order.getTips());
// }else {
//   viewHolder.tv_voucherDate.setTextColor(mContext.getResources().getColor(R.color.color_828282));
//   viewHolder.tv_voucherDate.setText(DateUtil.getDay(order.getStartDate() + "") + " 至 " + DateUtil.getDay(order.getEndDate() + ""));
// }



// WEBPACK FOOTER //
// ./src/util/timeFilter.js